import { observer } from "mobx-react";
import './index.css';
import { TextProfileIcon } from "../TextProfileIcon";
import strings from "../../localization";
import { Link, useNavigate } from "react-router";
import { formatDate, formatDateTime, formatDuration } from "../../helpers/functions";
import { IssueSolvedList } from "../../helpers/statics";
import TechCallSessionNotes from "../TechCallSessionNotes";
import { videoCameraIcon } from "../../assets";

const StateComponent = ({ result }) => {

  const resultItem = IssueSolvedList.find(item => item.key === result);
  const icon = resultItem?.icon;
  const title = resultItem?.title;
  const borderColor = resultItem?.color;
  const backgroundColor = resultItem?.backgroundColor;
  return (
    <div className="session-logs-item-container-state-component"
      style={{ backgroundColor: backgroundColor, borderColor: borderColor }}
    >
      <img src={icon} alt={title} />
      <span>{title}</span>
    </div>
  )
}

const LabelGroup = ({ label, value }) => {

  return (
    <div className="session-logs-item-container-label-group">
      <span className="session-logs-item-container-label-group-label">{label}</span>
      <span className="session-logs-item-container-label-group-value">{value}</span>
    </div>
  )
}

const LinkOrDiv = ({ to, children }) => {
  if (to) {
    return <Link className="session-logs-item-container-outer" to={to}>{children}</Link>
  }
  return children;
}

const SessionLogsItem = ({ call }) => {
  const { _id, createdAt, customer, technician, result, duration, slug, state, pin } = call;
  const fullName = `${technician.name} ${technician.surname}`;

  const navigate = useNavigate();

  const __to = state === 'end' ? `/tech/session/${slug}` : null;

  return (
    <LinkOrDiv to={__to}>
      <div className="session-logs-item-container" >
        <div className="session-logs-item-container-top">
          <div className="call-session-information-with-records-profile">
            <TextProfileIcon text={fullName} />
            <div className="call-session-information-with-records-profile-name">
              <span>{fullName}</span>
              <span>Slug: {slug}</span>
            </div>
          </div>
          <LabelGroup label={strings.customerPhoneNumber} value={customer} />
          <LabelGroup label={strings.date + ' / ' + strings.time} value={`${formatDateTime(createdAt)}`} />
          {duration && <LabelGroup label={strings.duration} value={formatDuration(duration)} />}
          {result ? <StateComponent result={result} /> : <div />}
          {state !== 'end' && <button
            style={{ marginLeft: 'auto' }}
            className="button-cta-secondary button-cta-medium" onClick={() => navigate(`/live/${slug}?pin=${pin}`)}>
            <img src={videoCameraIcon} alt="video-camera" style={{ filter: 'invert(1)' }} />
            <span>{strings.continueCall}</span>
          </button>}
        </div>
        <div className="session-logs-item-container-bottom">
          <div className="session-logs-item-container-bottom-notes">
            <span>{strings.sessionNotes}</span>
            <p>{call.note}</p>
          </div>
        </div>
      </div>
    </LinkOrDiv>
  );
};

export default observer(SessionLogsItem);